import { render, staticRenderFns } from "./LGPDSuporteModal.vue?vue&type=template&id=fb66b058"
import script from "./LGPDSuporteModal.vue?vue&type=script&lang=js"
export * from "./LGPDSuporteModal.vue?vue&type=script&lang=js"
import style0 from "./LGPDSuporteModal.vue?vue&type=style&index=0&id=fb66b058&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports